import { debounce } from '../../../js/default';

const transitionTab = (item, loop, delay) => {
  const activeTab = item.querySelector('.tab-title.nActive');
  const nextTab = activeTab.nextElementSibling || item.querySelector('.tab-title:first-child');

  const activeTabId = activeTab.getAttribute('tab-id');
  const nextTabId = nextTab.getAttribute('tab-id');

  activeTab.classList.remove('nActive');
  nextTab.classList.add('nActive');

  item.querySelector(`.js-tab[tab-id="${activeTabId}`).classList.remove('nActive');
  item.querySelector(`.js-tab[tab-id="${nextTabId}`).classList.add('nActive');

  if (loop) {
    setTimeout(() => {
      transitionTab(item, loop, delay);
    }, delay);
  }
};

(() => {
  // tabs

  // fn calc height if absolute
  const tabContentHeight = (e) => {
    const container = e.querySelector('.js-tabbed-content');
    const activeTab = e.querySelector('.js-tab.nActive');
    const tabHeight = activeTab.offsetHeight;

    container.style.height = `${tabHeight}px`;
  };

  // activate first tab
  document.querySelectorAll('.js-tabs').forEach((tabWrap) => {
    if (!tabWrap.querySelector('.nActive')) {
      tabWrap.firstElementChild.classList.add('nActive');
    }
  });
  document.querySelectorAll('.js-tabbed-content').forEach((tabContent) => {
    if (!tabContent.querySelector('.nActive')) {
      tabContent.firstElementChild.classList.add('nActive');
    }
  });
  document.querySelectorAll('.js-tab-images').forEach((tabImg) => {
    if (!tabImg.querySelector('.nActive')) {
      tabImg.firstElementChild.classList.add('nActive');
    }
  });

  // set height for first tab
  document.querySelectorAll('.module-content-tabs').forEach((item) => {
    tabContentHeight(item);

    // resize tab conatiner on window resize (debounced)
    function saveInput() {
      tabContentHeight(item);
    }
    const processChange = debounce(() => saveInput());

    document.addEventListener('scroll', () => {
      processChange();
    });
  });

  // click to change tab
  document.querySelectorAll('.tab-title').forEach((tabTitle) => {
    const changeTab = (e) => {
      const tab = e.currentTarget;
      const tabID = tab.getAttribute('tab-id');
      if (tab.classList.contains('nActive')) return;

      // Tab Title
      tab.parentNode.querySelector('.nActive')?.classList.remove('nActive');
      tab.classList.add('nActive');

      // Tab Content
      tabTitle.parentNode.nextElementSibling.querySelector('.nActive')?.classList.remove('nActive');
      tabTitle.parentNode.nextElementSibling.querySelector(`[tab-id="${tabID}"`).classList.add('nActive');
      $('.js-carousel-slider').slick('refresh');

      // BG Image
      tabTitle.closest('.js-tabs-container')?.querySelector('.js-tab-images .nActive')?.classList.remove('nActive');
      tabTitle.closest('.js-tabs-container')?.querySelector(`.js-tab-images [tab-id="${tabID}"`)?.classList.add('nActive');

      // for content tabs, we need to calc height as pos: absolute
      if (tab.closest('.module-content-tabs')) {
        tabContentHeight(tab.closest('.module-content-tabs'));
      }

      /**
       * Update iframe height on window resize
       */
      (() => {
        const query = tabTitle.parentNode.nextElementSibling.querySelector('iframe[title="YouTube video player"]');
        if (!query) return;

        const calcVideoHeight = (el) => {
          const width = el.offsetWidth;
          const height = width * (9 / 16);
          el.style.height = `${height}px`;
        };

        // Call the function initially to set the correct height on page load
        tabTitle.parentNode.nextElementSibling.querySelectorAll('iframe[title="YouTube video player"]').forEach((item) => {
          calcVideoHeight(item);
        });
      })();
    };

    tabTitle.addEventListener('click', (e) => {
      changeTab(e);
    });

    tabTitle.addEventListener('keyup', (e) => {
      if (!(e.key === 'Enter')) return;
      changeTab(e);
    });
  });

  /**
   * Tab Autoplay
   */
  (() => {
    document.querySelectorAll('.js-tabs-container[tab-autoplay="true"').forEach((item) => {
      setTimeout(() => {
        transitionTab(item, true, 5000);
      }, 5000);
    });
  })();
})();
